// src/App.js
import React from 'react';
import DepaLabHomepage from './components/home';

const App = () => {
  return <DepaLabHomepage />;
};

export default App;
